<script setup>
import { useGlobalStore } from '@stores/global'
import { onMounted } from 'vue'
import Button from '@components/global/button.vue'

const global = useGlobalStore()

onMounted(() => {
	document.cookie = hoodieEmbedWtbV2('f74b6c91-f32d-4cfd-adab-61ddad76907e', 'askhoodieDiv', document.cookie)
})
</script>
<template>
	<section class="container flex flex-col items-center gap-6 text-center">
		<span class="h9">To your door</span>
		<h2>Get Garden Mother Delivered</h2>
		<p class="lg:w-3/4">Visit one of our delivery partners below</p>
		<div class="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:gap-4">
			<Button class="primary large w-full" v-for="deliveryPartner in global.deliveryPartners" :key="deliveryPartner.slug" :label="deliveryPartner.name" :href="deliveryPartner.link" />
		</div>
	</section>

	<section class="bg-bgSecondary lg:mt-10 lg:pt-10">
		<div class="container flex flex-col gap-4 !pb-0 text-left">
			<h2>Dispensary Map</h2>
			<p>Search for dispensaries in your local area</p>
		</div>
		<section class="container flex flex-col gap-6 2xl:flex-row">
			<div class="w-full" id="askhoodieDiv"></div>
		</section>
	</section>
</template>
